module.exports = __webpack_public_path__ + "media/vectors/term-bg-4-5af9c270.jpg";